export function extrairYoutubeId(valor) {
  if (!valor) return "";

  let link = String(valor).trim();

  const iframeSrc = link.match(/src=["']([^"']+)["']/i);
  if (iframeSrc) {
    link = iframeSrc[1];
  }

  const idOnlyMatch = link.match(/^([\w-]{11})$/);
  if (idOnlyMatch) {
    return idOnlyMatch[1];
  }

  try {
    const url = new URL(link);
    const host = url.hostname.replace(/^www\./, "").replace(/^m\./, "");

    if (host === "youtu.be") {
      return url.pathname.split("/").filter(Boolean)[0] || "";
    }

    if (host === "youtube.com" || host === "youtube-nocookie.com") {
      const videoId = url.searchParams.get("v");
      if (videoId) return videoId;

      const parts = url.pathname.split("/").filter(Boolean);
      if (["embed", "v", "shorts", "live"].includes(parts[0])) {
        return parts[1] || "";
      }
    }
  } catch (error) {
    const idMatch = link.match(
      /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:.*[?&]v=|embed\/|v\/|shorts\/|live\/))([\w-]{11})/i
    );
    if (idMatch) return idMatch[1];
  }

  return "";
}

export function normalizarYoutubeEmbed(valor) {
  const id = extrairYoutubeId(valor);
  return id ? `https://www.youtube.com/embed/${id}` : String(valor || "").trim();
}

export function normalizarYoutubeWatch(valor) {
  const id = extrairYoutubeId(valor);
  return id ? `https://www.youtube.com/watch?v=${id}` : String(valor || "").trim();
}

export function normalizarYoutube(valor) {
  return normalizarYoutubeEmbed(valor);
}
